import { render, staticRenderFns } from "./ChangeContext.vue?vue&type=template&id=63b000a4&"
import script from "./ChangeContext.vue?vue&type=script&lang=js&"
export * from "./ChangeContext.vue?vue&type=script&lang=js&"
import style0 from "./ChangeContext.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports